<div class="ostso-dialog landmark">
    <div class="header">
        <button mat-icon-button class="close-button" (click)="onNoClick()">
            <mat-icon>close</mat-icon>
        </button>
        <h1>{{ isNew ? "Создание учреждения" : "Редактирование учреждения" }}</h1>

    </div>
    <div mat-dialog-content>
        <form class="form" [formGroup]="form">
            <input class="remarktype-textarea" matInput [formControlName]="'name'" placeholder="Учреждение">

            <input class="remarktype-textarea" matInput [formControlName]="'iasid'" placeholder="ID ИАС Спорт">

            <pas-multi-select3 [formControlName]="'group'"
                               title="Группа учреждения"
                               [customDataService]="groupService"
                               customDialogMethod="apiGroupGet"
                               filteredObjectName="organization"
                               type="radio"
                               [options]="options['group']"
            >
                <ng-template #listItem let-item>
                    {{ item.name }}
                </ng-template>
                <ng-template #dialogList let-item>
                    {{ item.name }} ({{ item.shortName }}) (ID:{{ item.id }})
                </ng-template>
            </pas-multi-select3>

            <pas-multi-select3 [formControlName]="'object'"
                               title="Группы объектов"
                               [customDataService]="groupService"
                               customDialogMethod="apiGroupGet"
                               type="radio"
                               [options]="options['object']"
            >
                <ng-template #listItem let-item>
                    {{ item.name }}
                </ng-template>
                <ng-template #dialogList let-item>
                    {{ item.name }} ({{ item.shortName }}) (ID:{{ item.id }})
                </ng-template>
            </pas-multi-select3>

            <pas-multi-select3 [formControlName]="'excludedIndicators'"
                               title="Исключение показателей"
                               [customDataService]="indicatorService"
                               customDialogMethod="apiIndicatorGet"
                               type="checkbox"
                               [options]="options['excludedIndicators']"
            >
                <ng-template #listItem let-item>
                    {{ item.name }}
                </ng-template>
                <ng-template #dialogList let-item>
                    {{ item.name }} ({{ item.shortName }}) (ID:{{ item.id }})
                </ng-template>
            </pas-multi-select3>

            <mat-expansion-panel [expanded]="true" class="mat-elevation-z0"
                                 [style]="{'background-color': '#F3F4F6'}">
                <mat-expansion-panel-header>ЦБ</mat-expansion-panel-header>
                <div class="controls" [style]="{'justify-content': 'flex-start'}" formArrayName="cb">
                    @for (item of cbs.controls; track item.value; let i = $index) {
                        <div class="control" [class.active]="hasCbType(i)">
                            <input type="checkbox" [formControlName]="i" name="cb"/>
                            <span>{{ cbTypes[i].name }}</span>
                        </div>
                    }
                </div>
            </mat-expansion-panel>

            <input class="remarktype-textarea" matInput [formControlName]="'email'" placeholder="E-mail">

            <br/>


        </form>
    </div>
    <div mat-dialog-actions>
        <button class="btn btn-blue" mat-button cdkFocusInitial (click)="onApply()" [disabled]="form.invalid">
            Применить
        </button>
        <button class="btn btn-secondary" mat-button (click)="onNoClick()">Сбросить</button>
    </div>
</div>

